import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ProductService } from 'src/app/services/product.service';

@Injectable({
  providedIn: 'root',
})
export class ProductResolve  {
  constructor(private productService: ProductService) {}

  async resolve(next: ActivatedRouteSnapshot) {
    const allProducts = await this.productService.getAllProducts();
    const product = allProducts.find(product => product.name.toLowerCase() === next.params.productName);
    return product;
  }
}
